import buildingStatusTypeOptions from './building-status-type';

const options = ['newBuilding', 'secondary'];

export default options.map(type => {
  return buildingStatusTypeOptions.find(item => item.value === type);
});
